import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type NotificationPreModalProps = InheritableModalProps & {
  onAction: () => void
}

const NotificationPreModal = ({ onAction, ...props }: NotificationPreModalProps) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <FontAwesomeIcon icon={faBell} fontSize={24} />

        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {t({
            id: 'notification.pre-modal.title',
            comment: 'title for the modal asking for notification permissions',
            message: 'Meldingen aanzetten',
          })}
        </H3>

        <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'notification.pre-modal.body',
            comment: 'body for the modal asking for notification permissions',
            message: 'Activeer je meldingen zodat we je op de hoogte kunnen houden van je komende afspraken en taken.',
          })}
        </P>

        <Button variant='Primary' onClick={onAction}>
          {t({
            id: 'notification.pre-modal.action.button',
            comment: ' action button for the modal asking for notification permissions',
            message: 'Activeer meldingen',
          })}
        </Button>
        <Margin mt={theme.UI.Spacing.Space2} />
        <Button variant='Tertiary' onClick={props.onClose}>
          {t({
            id: 'notification.pre-modal.cancel.button',
            comment: 'cancel button for the modal asking for notification permissions',
            message: 'Niet nu',
          })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}

export { NotificationPreModal }
